import type { Category, Subcategory } from './category';
import type { Company } from './company';
import type { CostCenter } from './cost-center';
import type { Document } from './document';
import type { Money } from './money';

export const DocumentAllocationResourceType = 'document-allocation';

export interface DocumentAllocation {
  id: string;
  amount: Money;
  itemDescription?: string | null;
  lineNumber?: string | null;
  createdAt?: string;
  document?: Document;
  company?: Company;
  category?: Category;
  subcategory?: Subcategory;
  costCenter?: CostCenter;
}

export interface DocumentAllocationUpdatePayload {
  lid: string;
  amount: Money;
  itemDescription?: string;
  lineNumber?: number;
  category?: {
    id: Category['id'];
  } | null;
  subcategory?: {
    id: Subcategory['id'];
  } | null;
  costCenter?: {
    id: CostCenter['id'];
  } | null;
}
